import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, MenuItem, Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material'
import { DatePicker } from '@mui/lab';
import GridBreak from '../../../../components/GridBreak'
import IFramePopUp from '../../../../components/Pop_ups/IFramePopUp';
import DragFiles from "../../../../components/FileManagement/DragFiles";
import { fileTo64Arr, handleFormNumbers } from "../../../../util/generalHelp";
import { createContractDraft, submitDraft, removeOfferDraft, getFieldClause } from "../../../../util/offerLettersHelp";
import { previewDocusign } from "../../../../util/docusignHelper";
import { useBeforeunload } from 'react-beforeunload';
import { useBackListener } from "../../../../util/Hooks";
import moment from "moment";
import { getProfileFromEmail } from "../../../../util/ProfileHelper";

function MasterOfServicesCanadian(props) {

    const defaultObj = {
            document_args: {},
            region: 'CAN',
            name: "",
            email_address: "",
            "return_url": window.location.origin.toString()
        }

    /* All of the fields that can be added to the Master of Services agreement, which initially we assume are not present */   
    const defaultFieldsMasterServices = {
        term: false,
        services: false,
        compensation: false,
        parties_relationship: false,
        intellectual_property: false,
        termination: false,
        indemnification: false,
        surviving_obligations: false,
        heading: true,
        entire_agreement:true,
        governing: true,
        notices: true,
        customMasterServices: false
    }

    const defaultFieldsStatementOfWork = {
        services_SOW: false,
        performance_period: false,
        fees: false,
        payment_terms: false,
        customStatementOfWork: false
    }


    const changeFieldMasterServices = function (field, value) {
        let newFieldsMasterServices = { ...fieldsMasterServices }
        newFieldsMasterServices[field] = value
        if (!value)
        {
            const keyClause = field
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
        }
        setFieldsMasterServices(newFieldsMasterServices)
    }

    const changeFieldStatementOfWork = function (field, value) {
        let newFieldsStatementOfWork = { ...fieldsStatementOfWork }
        if (!value)
        {
            const keyClause = field
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
        }
        newFieldsStatementOfWork[field] = value
        setFieldsStatementOfWork(newFieldsStatementOfWork)
    }

    const handleDefaultClause = function (keyClause, contract, checked)
    {
        props.setLoading(true)
        if (checked)
        {
            if (!defaultContractText[keyClause])
                getFieldClause(keyClause, contract, 'can_contract', (json) =>
            {
                if (json)
                {
                    console.log(json)
                    let newDefaultContractText = {...defaultContractText}
                    newDefaultContractText[keyClause] = json.clauses
                    setDefaultContractText(newDefaultContractText)
                    let newShowEdits = {...showEditClause}
                    newShowEdits[keyClause] = true
                    setShowEditClause(newShowEdits)
                    
                }
                else
                    props.setError("The requested clause text could not be fetched. This is usually due to server error.")
                props.setLoading(false)
            })
            else
            {
                let newShowEdits = {...showEditClause}
                newShowEdits[keyClause] = true
                setShowEditClause(newShowEdits)
                props.setLoading(false)
            }
        }
        else
        {
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultContractText = {...defaultContractText}
            delete newDefaultContractText[keyClause]
            setDefaultContractText(newDefaultContractText)
            props.setLoading(false)
        }
    }

    const [requestObj, setRequestObj] = useState({ ...defaultObj })
    const [previewUrl, setPreviewUrl] = useState()
    const [previewClicked, setPreviewClicked] = useState(false)
    const [envelopeId, setEnvelopeId] = useState("")
    const [fileArr, setFileArr] = useState([])
    const [uploadStatus, setUploadStatus] = useState('error')
    const [fieldsMasterServices, setFieldsMasterServices] = useState({ ...defaultFieldsMasterServices })
    const [fieldsStatementOfWork, setFieldsStatementOfWork] = useState({ ...defaultFieldsStatementOfWork })
    const [defaultContractText, setDefaultContractText] = useState({})
    const [showEditClause, setShowEditClause] = useState({})
    const [checkAll, setCheckAll] = useState(false)

    useEffect(() => {
        if (fieldsStatementOfWork.services)
        {
            let newObj = {...requestObj}
            newObj['document_args']['client_name'] = ""
            newObj['document_args']['service_description'] = ""
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['client_name']
            delete newObj['document_args']['service_description']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.services])

    useEffect(() => {
        if (fieldsStatementOfWork.performance_period)
        {
            let newObj = {...requestObj}
            newObj['document_args']['effective_date'] = moment().format('YYYY-MM-DD')
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['effective_date']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.performance_period])


    useEffect(() => {
        if (fieldsMasterServices.term)
        {
            let newObj = {...requestObj}
            newObj['document_args']['term_start'] = moment().format('MMMM DD, YYYY')
            newObj['document_args']['term_end'] = moment().format('MMMM DD, YYYY')
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['term_start']
            delete newObj['document_args']['term_end']
            setRequestObj(newObj)
        }
    }    
    , [fieldsMasterServices.term])

    useEffect(() => {
        if (fieldsMasterServices.termination)
        {
            let newObj = {...requestObj}
            newObj['document_args']['contract_termination_date'] = moment().format('MMMM DD, YYYY')
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['contract_termination_date']
            setRequestObj(newObj)
        }
    }    
    , [fieldsMasterServices.termination])

    useEffect(() => {
        if (fieldsStatementOfWork.fees)
        {
            let newObj = {...requestObj}
            newObj['document_args']['rate_type'] = "daily"
            newObj['document_args']['salary'] = 0
            setRequestObj(newObj)
        }
        else
        {
            let newObj = {...requestObj}
            delete newObj['document_args']['rate_type']
            delete newObj['document_args']['salary']
            setRequestObj(newObj)
        }
    }    
    , [fieldsStatementOfWork.fees])

    useEffect(() => {
            if (fileArr && fileArr.length > 0) {
                setUploadStatus('success')
            } else {
                setUploadStatus('pending')
            }
        }, [fileArr])

    useBackListener(({ location }) => {
            if (requestObj.id) {
                removeOfferDraft(requestObj.id, (resp) => { }, true)
            }
        })
    
    
        useBeforeunload((event) => {
            if (requestObj.id) {
                removeOfferDraft(requestObj.id, (resp) => { }, true)
    
            }
        });

    const closePreview = () => {
            setPreviewClicked(false)
            previewDocusign(envelopeId, (json) => {
                if (json) {
                    setPreviewUrl(json.redirect_url)
                }
            })
        }

    const updateDocument = (key, value) => {
            let newDoc = { ...requestObj }
            if (key == 'seq_hire_helper') {
                newDoc['document_args']['seq_hire_statement'] = defaultObj.document_args.seq_hire_statement.replace(/X/, `${value}`)
            }
                newDoc['document_args'][key] = value
            setRequestObj(newDoc)
        }

    const handleDraft = async () => {
            if (previewUrl && requestObj.id) {
                props.setLoading(true)
                submitDraft(requestObj.id, envelopeId, (resp) => {
                    if (resp) {
                        setRequestObj(defaultObj)
                        setFileArr([])
                        setPreviewUrl()
                        setEnvelopeId("")
                        if (props.onComplete) {
                            props.onComplete()
                        }
                    } else {
                        props.onError({})
                    }
                    props.setLoading(false)
                })
            } else {
                props.setLoading(true)
                setPreviewUrl()
                if (checkJson(requestObj.document_args)) {
                    getProfileFromEmail(async (profile) => 
                    {
                    let request_obj = { ...requestObj }
                    request_obj.document_b64s = await handleFile(fileArr)
                    const jsonSend = {request_obj: request_obj, contract: 'MasterServices', fields: ['fieldsMasterServices', 'fieldsStatementOfWork'], fieldsMasterServices: fieldsMasterServices, fieldsStatementOfWork: fieldsStatementOfWork, default_changes: defaultContractText, sender: profile.id}
                    createContractDraft(jsonSend, (resp) => {
                        if (resp) {
                            updateOffer('id', resp.id)
                            setPreviewUrl(resp.redirect_url)
                            setUploadStatus('disabled')
                            setEnvelopeId(resp.envelope_id)
                        } else {
                            props.onError({})
                        }
                        props.setLoading(false)
                    })
                })
                } else {
                    props.onError({ errorTitle: 'Missing Form Fields', errorContent: "Please fill out all available form fields" })
                    props.setLoading(false)
                }
    
            }
    
        }
    
    const checkJson = (json) => {
            for (const key of Object.keys(json)) {
                if (json[key] === null || json[key] === undefined || json[key] === '') {
                    if (!props.optionalFields.includes(key))
                        return false
                }
    
                if (json[key].constructor == Object) {
                    if (!checkJson(json[key])) {
                        return false
                    }
                    continue
                }
            }
            return true
        }
    
        const updateOffer = (key, value, del = false) => {
            let newOffer = { ...requestObj }
            if (!del) {
                newOffer[key] = value
                setRequestObj(newOffer)
            } else {
                delete newOffer[key]
                setRequestObj(newOffer)
            }
    
        }    

    const handleClear = () => {
        if (requestObj.id) {
            props.setLoading(true)
            removeOfferDraft(requestObj.id, (resp) => {
                if (resp) {
                    let newOffer = { ...requestObj }
                    delete newOffer['id']
                    setRequestObj(newOffer)
                    setPreviewUrl()
                    setUploadStatus('pending')
                } else {
                    props.onError({})
                }
                props.setLoading(false)
            })
        }
    }

    const handleFile = async (fileArr) => {
        return await fileTo64Arr(fileArr)
    }

    const handleNumberForm = (e, key, document = false, decimals = 0, maxdigits = undefined) => {
        let modfiedNum = handleFormNumbers(e.target.value, decimals, false, maxdigits)
        if (modfiedNum !== undefined) {
            if (document) {
                updateDocument(key, modfiedNum)
            } else {
                updateOffer(key, modfiedNum)
            }
        }
    }


    const handleCheckAll = (e) => {
        let newFieldsMasterServices = { ...fieldsMasterServices }
        let newFieldsStatementOfWork = { ...fieldsStatementOfWork }
        for (const key of Object.keys(newFieldsMasterServices)) {
            newFieldsMasterServices[key] = e.target.checked
        }
        for (const key of Object.keys(newFieldsStatementOfWork)) {
            newFieldsStatementOfWork[key] = e.target.checked
        }
        setFieldsMasterServices(newFieldsMasterServices)
        setFieldsStatementOfWork(newFieldsStatementOfWork)
        setCheckAll(e.target.checked)
    }

    //Length is the maximum length of the clause in question, in case there are multiple fields
    const changeDefaultText = function (key, value, index, length)
    {
        let newDefault = {...defaultContractText}
        if (index !== undefined && newDefault[key] !== undefined)
            newDefault[key][index] = value
        else if (index !== undefined)
        {
            newDefault[key] = Array(length)
            //Populate the newly created array with the initial text from the document
            let i = 0
            while (i < length)
            {
                newDefault[key][i] = defaultContractText[key][i]
                i++
            }
            newDefault[key][index] = value
        }
        else
            newDefault[key] = value
        setDefaultContractText(newDefault)
    }

    


    return (
        <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', width: '100%', padding: '1%' }}>
            <IFramePopUp open={previewClicked} url={previewUrl} onClose={closePreview} maxRedirect={2} />
            <Typography sx ={{'align-self': 'flex-start'}} variant='h5'>Choose Fields</Typography>
            <FormGroup item sx={{ width: '100%', padding: '1%' }}>
                <FormControlLabel control={ <Checkbox checked = {checkAll} onChange = {handleCheckAll} /> } label = {"Check/Uncheck All"} />
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.term} onChange = {(e) => changeFieldMasterServices("term", e.target.checked)} /> } label = {"Terms"} />
                {fieldsMasterServices.term ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.term} onChange = {(e) => handleDefaultClause("term", "MasterServices", e.target.checked)} /> } label = {"Edit Term Clause"} />
                        {showEditClause.term ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                                For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <Typography sx = {{'margin': '1%'}}>
                            Any text within the curly brackets and including them must remain unchanged for the document populator to function correctly.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Term Clause"
                            value= {defaultContractText.term} onChange= {(e) => changeDefaultText("term", e.target.value)} fullWidth required multiline /> 
                        </>: <></>
                        }
                        
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.services} onChange = {(e) => changeFieldMasterServices("services", e.target.checked)} /> } label = {"Services Clause Master Professional Services"} />
                {fieldsMasterServices.services ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.services} onChange = {(e) => handleDefaultClause("services", "MasterServices", e.target.checked)} /> } label = {"Edit Services Clause"} />
                        {showEditClause.services ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Services Part 1"
                                value= {defaultContractText.services[0]} onChange= {(e) => changeDefaultText("services", e.target.value, 0, 2)} fullWidth required multiline />
                            <TextField sx = {{'margin': '1%'}} label="Current Services Part 2"
                                value= {defaultContractText.services[1]} onChange= {(e) => changeDefaultText("services", e.target.value, 1, 2)} fullWidth required multiline /> 
                        </>        
                        : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.compensation} onChange = {(e) => changeFieldMasterServices("compensation", e.target.checked)} /> } label = {"Compensation"} />
                {fieldsMasterServices.compensation ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.compensation} onChange = {(e) => handleDefaultClause("compensation", "MasterServices", e.target.checked)} /> } label = {"Compensation Clause"} />
                        {showEditClause.compensation ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <Typography sx = {{'margin': '1%'}}>
                                Any text within the curly brackets and including them must remain unchanged for the document populator to function correctly.
                        </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Compensation"
                                value= {defaultContractText.compensation} onChange= {(e) => changeDefaultText("compensation", e.target.value)} fullWidth required multiline />
                        </>
                            : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.parties_relationship} onChange = {(e) => changeFieldMasterServices("parties_relationship", e.target.checked)} /> } label = {"Relationship of the Parties"} />
                {fieldsMasterServices.parties_relationship ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel item  control={ <Checkbox checked = {showEditClause.parties_relationship} onChange = {(e) => handleDefaultClause("parties_relationship", "MasterServices", e.target.checked)} /> } label = {"Relationship of the Parties Clause"} />
                        {showEditClause.parties_relationship ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Relationship of the Parties Clause"
                            value= {defaultContractText.parties_relationship} onChange= {(e) => changeDefaultText("parties_relationship", e.target.value)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.intellectual_property} onChange = {(e) => changeFieldMasterServices("intellectual_property", e.target.checked)} /> } label = {"Intellectual Property"} />
                {fieldsMasterServices.intellectual_property ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.intellectual_property} onChange = {(e) => handleDefaultClause("intellectual_property", "MasterServices", e.target.checked)} /> } label = {"Edit Intellectual Property Clause"} />
                        {showEditClause.intellectual_property ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Intellectual Property Clause"
                            value= {defaultContractText.intellectual_property} onChange= {(e) => changeDefaultText("intellectual_property", e.target.value)} fullWidth required multiline /> </> : 
                        <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.termination} onChange = {(e) => changeFieldMasterServices("termination", e.target.checked)} /> } label = {"Termination"} />
                {fieldsMasterServices.termination ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.termination} onChange = {(e) => handleDefaultClause("termination", "MasterServices", e.target.checked)} /> } label = {"Edit Termination Clause"} />
                        {showEditClause.termination ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <Typography sx = {{'margin': '1%'}}>
                                Any text within the curly brackets and including them must remain unchanged for the document populator to function correctly.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Termination Clause"
                            value= {defaultContractText.termination} onChange= {(e) => changeDefaultText("termination", e.target.value)} fullWidth required multiline /> 
                        </>
                            : <></>

                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.indemnification} onChange = {(e) => changeFieldMasterServices("indemnification", e.target.checked)} /> } label = {"Indemnification"} />
                {fieldsMasterServices.indemnification ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.indemnification} onChange = {(e) => handleDefaultClause("indemnification", "MasterServices", e.target.checked)} /> } label = {"Edit Indemnification Clause"} />
                        {showEditClause.indemnification ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Indemnification Clause"
                                value= {defaultContractText.indemnification} onChange= {(e) => changeDefaultText("indemnification", e.target.value)} fullWidth required multiline /> 
                        </>
                        : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.surviving_obligations} onChange = {(e) => changeFieldMasterServices("surviving_obligations", e.target.checked)} /> } label = {"Surviving Obligations"} />
                {fieldsMasterServices.surviving_obligations ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.surviving_obligations} onChange = {(e) => handleDefaultClause("surviving_obligations", "MasterServices", e.target.checked)} /> } label = {"Edit Surviving Obligations Clause"} />
                        {showEditClause.surviving_obligations ?
                        <>
                        <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                        </Typography>
                        <TextField sx = {{'margin': '1%'}} label="Current Surviving Obligations Clause"
                            value= {defaultContractText.surviving_obligations} onChange= {(e) => changeDefaultText("surviving_obligations", e.target.value)} fullWidth required multiline /> 
                        </>
                        : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsMasterServices.customMasterServices} onChange = {(e) => changeFieldMasterServices("customMasterServices", e.target.checked)} /> } label = {"Add a Master Professional Services Custom Field"} />
                {fieldsMasterServices.customMasterServices ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current Master Services Custom Header"
                                value= {defaultContractText.customMasterServicesHeader} onChange= {(e) => changeDefaultText("customMasterServicesHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current Master Services Custom Clause"
                                value= {defaultContractText.customMasterServices} onChange= {(e) => changeDefaultText("customMasterServices", e.target.value)} fullWidth required multiline />
                        </Grid>
                         : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.services_SOW} onChange = {(e) => changeFieldStatementOfWork("services_SOW", e.target.checked)} /> } label = {"Statement of Work Services"} />
                {fieldsStatementOfWork.services_SOW ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.services_SOW} onChange = {(e) => handleDefaultClause("services_SOW", "MasterServices", e.target.checked)} /> } label = {"Edit Statement of Work Services Clause"} />
                        {showEditClause.services_SOW ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                            The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Services Clause"
                                value= {defaultContractText.services_SOW} onChange= {(e) => changeDefaultText("services_SOW", e.target.value)} fullWidth required multiline />     
                        </> 
                        : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.performance_period} onChange = {(e) => changeFieldStatementOfWork("performance_period", e.target.checked)} /> } label = {"Statement of Work Performance Period"} />
                {fieldsStatementOfWork.performance_period ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.performance_period} onChange = {(e) => handleDefaultClause("performance_period", "MasterServices", e.target.checked)} /> } label = {"Edit Performance Period Clause"} />
                        {showEditClause.performance_period ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Performance Period Clause"
                                value= {defaultContractText.performance_period} onChange= {(e) => changeDefaultText("performance_period", e.target.value)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.fees} onChange = {(e) => changeFieldStatementOfWork("fees", e.target.checked)} /> } label = {"Statement of Work Fees"} />
                {fieldsStatementOfWork.fees ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.fees} onChange = {(e) => handleDefaultClause("fees", "MasterServices", e.target.checked)} /> } label = {"Edit Fees Clause"} />
                        {showEditClause.fees ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Fees Clause"
                                value= {defaultContractText.fees} onChange= {(e) => changeDefaultText("fees", e.target.value)} fullWidth required multiline />
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.payment_terms} onChange = {(e) => changeFieldStatementOfWork("payment_terms", e.target.checked)} /> } label = {"Statement of Work Payment Terms"} />
                {fieldsStatementOfWork.payment_terms ?
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        
                        <FormControlLabel  control={ <Checkbox checked = {showEditClause.payment_terms} onChange = {(e) => handleDefaultClause("payment_terms", "MasterServices", e.target.checked)} /> } label = {"Edit Payment Terms Clause"} />
                        {showEditClause.payment_terms ?
                        <>
                            <Typography sx = {{'margin': '1%'}}>
                                The curly brackets {} denote user defined input from the fields below. They can be kept or removed, but more can't be added.
                            </Typography>
                            <Typography sx = {{'margin': '1%'}}>
                            For the sake of document format, do not remove any special characters or spaces preceding or succeeding the text.
                            </Typography>
                            <TextField sx = {{'margin': '1%'}} label="Current Payment Terms Clause"
                                value= {defaultContractText.payment_terms} onChange= {(e) => changeDefaultText("payment_terms", e.target.value)} fullWidth required multiline /> 
                        </> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsStatementOfWork.customStatementOfWork} onChange = {(e) => changeFieldStatementOfWork("customStatementOfWork", e.target.checked)} /> } label = {"Add a Statement of Work Custom Field"} />
                {fieldsStatementOfWork.customStatementOfWork ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Header"
                                value= {defaultContractText.customStatementOfWorkHeader} onChange= {(e) => changeDefaultText("customStatementOfWorkHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current Statement of Work Custom Clause"
                                value= {defaultContractText.customStatementOfWork} onChange= {(e) => changeDefaultText("customStatementOfWork", e.target.value)} fullWidth required multiline />
                        </Grid>
                         : <></>
                }
            </FormGroup>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Name" onChange={(e) => { e.preventDefault(); updateOffer('name', e.target.value) }}
                            value={requestObj.name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Company Name" onChange={(e) => { e.preventDefault(); updateDocument('company_name', e.target.value) }}
                            value={requestObj.document_args.company_name} fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Employer Address" onChange={(e) => { e.preventDefault(); updateDocument('employer_address', e.target.value) }}
                            value={requestObj.document_args.employer_address} fullWidth required />
                    </Grid>
                    { fieldsMasterServices.services || fieldsStatementOfWork.services_SOW ? 
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Client Name" onChange={(e) => { e.preventDefault(); updateDocument('client_name', e.target.value) }}
                            value={requestObj.document_args.client_name} fullWidth required />
                    </Grid> : <></> }
                    {fieldsMasterServices.services || fieldsStatementOfWork.services_SOW  ? 
                    <Grid item xs={6}>
                        <TextField disabled={Boolean(previewUrl)} label="Services Description" onChange={(e) => { e.preventDefault(); updateDocument('services_description', e.target.value) }}
                            value={requestObj.document_args.services_description} fullWidth required multiline />
                    </Grid> : <></> }
                    {fieldsMasterServices.term ?
                        <Grid item xs={3}>
                            <DatePicker disabled={Boolean(previewUrl)} label="Start of Term" value={requestObj.document_args.term_start}
                                onChange={(value) => updateDocument('term_start', value.format(('MMMM DD, YYYY')).toString())}
                                renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid> : <></>}
                    {fieldsMasterServices.term ?
                        <Grid item xs={3}>
                            <DatePicker disabled={Boolean(previewUrl)} label="End of Term" value={requestObj.document_args.term_end}
                                onChange={(value) => updateDocument('term_end', value.format(('MMMM DD, YYYY')).toString())}
                                renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid> : <></>}
                    { fieldsMasterServices.compensation || fieldsStatementOfWork.fees ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'hourly_rate', true, 3)
                            }}
                                label={'Hourly Rate ($/hr) CAD'}
                                value={requestObj.document_args.hourly_rate} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    { fieldsMasterServices.compensation || fieldsStatementOfWork.fees ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'overtime_rate', true, 3)
                            }}
                                label={'Overtime Rate ($/hr) CAD'}
                                value={requestObj.document_args.overtime_rate} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    { fieldsMasterServices.compensation || fieldsStatementOfWork.fees ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'regular_hours', true, 3)
                            }}
                                label={'Maximum Hours Before Overtime'}
                                value={requestObj.document_args.regular_hours} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    { fieldsMasterServices.termination ? 
                        <Grid item xs={3}>
                            <DatePicker disabled={Boolean(previewUrl)} label="Contract Termination Date" value={requestObj.document_args.contract_termination_date}
                                onChange={(value) => updateDocument('contract_termination_date', value.format(('MMMM DD, YYYY')).toString())}
                                renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid>    
                    : <></>
                    }
                    {fieldsStatementOfWork.performance_period ? 
                        <Grid item xs={3}>
                        <DatePicker disabled={Boolean(previewUrl)} label="SOW Effective Date" value={requestObj.document_args.effective_date}
                            onChange={(value) => updateDocument('effective_date', value.format('YYYY-MM-DD').toString())}
                            renderInput={(params) => <TextField required fullWidth {...params} />} />
                        </Grid>
                        : <></>
                    }
                    { fieldsStatementOfWork.performance_period ? 
                        <Grid item xs={3}>
                            <TextField disabled={Boolean(previewUrl)} SelectProps='0.01' onChange={(e) => {
                                e.preventDefault();
                                handleNumberForm(e, 'duration', true, 3)
                            }}
                                label={'Performance Period Duration (in months)'}
                                value={requestObj.document_args.duration} fullWidth required />
                        </Grid>    
                    : <></>
                    }
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} required label="Signing Authority" onChange={(e) => { e.preventDefault(); updateOffer('authority_id', e.target.value) }}
                            value={requestObj.authority_id} fullWidth select>
                            {props.authorities.map((auth) => (
                                <MenuItem key={auth.id} value={auth.id}>
                                    {auth.name}({auth.email_address})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Statement Of Work Number"
                            onChange={(e) => {
                                e.preventDefault();
                                updateDocument('SOW_number', e.target.value)
                            }}
                            value={requestObj.document_args.SOW_number} fullWidth required multiline />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField disabled={Boolean(previewUrl)} label="Signatory Email" onChange={(e) => { e.preventDefault(); updateOffer('email_address', e.target.value) }}
                            value={requestObj.email_address} fullWidth required />
                    </Grid>
                    <GridBreak />
                    <Grid item container xs={12} sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <DragFiles types={props.fileTypes} multiple={true} disabled={Boolean(previewUrl)} onUpdate={setFileArr}
                            maxSize={15}
                            onTypeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Type Error', errorContent: error }) }}
                            onSizeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Size Error', errorContent: error }) }}
                            uploadStatus={uploadStatus} />
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); handleClear() }}>Cancel</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); setPreviewClicked(true) }}>Preview Document</Button>
                    </Grid>
                    <Grid item xs={4} container sx={{ justifyContnet: 'center', alignItems: 'center' }}>
                        <Button fullWidth onClick={(e) => { e.preventDefault(); handleDraft() }}>{requestObj.id && previewUrl ? "Send" : "Create Draft"}</Button>
                    </Grid>
                </Grid>
    );
}

export default MasterOfServicesCanadian;